import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import Text from 'components/Text/Text';
import style from './ModifierGroupsAsAdditionalField.module.scss';

const ModifierGroupsAsAdditionalField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	const modifierGroupAsAdditional = dishForFullInfo?.modifierGroups.filter((el) => el.isAdditional);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="useAsAdditionalCountLabel"
				translationOptions={{ count: modifierGroupAsAdditional?.length }}
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.groupsList}>
				{modifierGroupAsAdditional?.length
					? modifierGroupAsAdditional.map((el) => {
							return (
								<div key={el.modifierGroupId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.modifierGroupName} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default ModifierGroupsAsAdditionalField;
